<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" size="mini" :model="pages" class="filter-panel">
				<el-form-item :label="$t('course_index.cate')" prop="cate" data-name="分类">
					<el-cascader v-model="pages.cate" class="w100" :props="props_" :options="camp_list"></el-cascader>
				</el-form-item>
				<el-form-item :label="$t('course_index.date')" prop="date" data-name="日期">
					<el-date-picker v-model="pages.week_time" type="week" class="select_select" value-format="yyyy-MM-dd" :format="lang=='cn'?'yyyy 第 WW 周':'yyyy WW week'" :placeholder="lang=='cn'?'选择周':'Week'"></el-date-picker>
				</el-form-item>
				<el-form-item :label="$t('course_index.age')" prop="age" data-name="年龄">
					<el-select v-model="pages.age" class="w100" clearable :placeholder="$t('index.select')">
						<el-option v-for="(item,index) in COURSEAGE_ARR" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.session')" prop="session" data-name="学期">
					<el-select v-model="pages.session" clearable class="w100" :placeholder="$t('index.pleaseInput')">
						<el-option v-for="(item,index) in SESSION_ARR" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.center')" prop="center_id" data-name="学习中心">
					<el-select v-model="pages.center_id" clearable class="w100" :placeholder="$t('index.select')">
						<el-option v-for="(item,index) in learnCenter" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.id" v-if="item.course_type==0||item.course_type==2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.teacher')" prop="teacher_id" data-name="老师">
					<el-select v-model="pages.teacher_id" clearable class="w100" :placeholder="$t('index.select')">
						<el-option v-for="(item,index) in teacher" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.teacher_id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.title')" prop="keyword" data-name="名称">
					<el-input v-model="pages.keyword" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item label="ID" prop="ID" data-name="id">
					<el-input v-model="pages.id" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" @click="search()">{{$t('index.search')}}</el-button>
					<el-button type="primary" size="mini" @click="reset()">{{$t('index.reset')}}</el-button>
				</el-form-item>
			</el-form>
			<div class="list-opinion fr">
				<div style="margin-bottom:5px;text-align:right">
					<el-button type="primary" size="mini" @click="add('')" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
				</div>
				<el-button type="primary" size="mini" @click="importtemplate('')">{{$t('index.importtemplate')}}</el-button>
				<el-upload class="upload_" v-if="!hasBtn('import')" :action="API_UP+'campImport'" name="excel" :data="{TokenId:TokenId}" :show-file-list="false" :before-upload="before_upload" :on-success="(res)=>{imageSuccess_f(res)}">
					<el-button size="mini" type="primary">{{$t('index.import')}}</el-button>
				</el-upload>
			</div>
		</div>
		<el-checkbox-group v-model="course_id_array">
			<el-table :data="list" size="mini" border class="teacher_course_camp">
				<el-table-column prop="id" align="center" label="ID" data-name="id"></el-table-column>
				<el-table-column :prop="lang=='cn'?'title_cn':'title'" align="center" :label="$t('course_index.title')" data-name="名称" width="150">
					<template slot-scope="{row}">
						<a target="_blank" class="clo3" :href="API_URL+'#/course_camps_info?id='+row.id">{{lang=='cn'?row.title_cn:row.title}}</a>
					</template>
				</el-table-column>
				<el-table-column prop="term" align="center" :label="$t('course_index.session')" data-name="学期">
					<template slot-scope="scope">{{scope.row.term | term_f(this_)}}</template>
				</el-table-column>
				<el-table-column prop="week" align="center" :label="$t('course_index.sort')" data-name="周" width="600">
					<template slot-scope="scope">
						<div class="kuai_kuai" v-for="(item,indexs) in scope.row.week_data" :key="indexs">
							<div v-for="(items,indexss) in item.camp_theme_data" class="kuai" :key="indexss">
								<div class="neir">
									<p>{{getTime_us(item.start_date_time,'mmddyyyy')}} ~ {{getTime_us(item.end_date_time,'mmddyyyy')}}</p>
									<p>{{getTime_us(items.start_time,'hh:ii')}} ~ {{getTime_us(items.end_time,'hh:ii')}}</p>
									<p>{{lang=='cn'?items.teacher_name_cn:items.teacher_name}}</p>
									<p>{{lang=='cn'?items.theme_cn:items.theme}}</p>
								</div>
								<div class="anjian">
									<div class="jeishao">{{items.student_num+'/'+items.num}} {{items.status>1?$t('course_index.upcoming_'):$t('course_index.ongoing_')}}</div>
									<div class="duqi">
										<div>
											<el-button size="mini" type="primary" v-if="hasBtn('Student_list')" data-name="学生列表" @click="teacher_course_index_id=items.id,isdialog=true">{{$t('course_index.student_list')}}</el-button>
										</div>
										<div>
											<el-button size="mini" type="primary" v-if="hasBtn('class_starts')&&scope.row.status==1" data-name="开营" @click="kaike(items)">{{$t('course_index.camp_start')}}id:{{items.id}}</el-button>
										</div>
										<div>
											<el-button size="mini" type="primary" v-if="hasBtn('virtual')&&items.status>1" data-name="虚拟班级" @click="router_url('/virtual_index',{id:items.id,course_type:'camp'})">{{$t('course_index.virtual')}}</el-button>
										</div>
										<div>
											<el-button size="mini" type="primary" v-if="hasBtn('virtual')" data-name="邮件记录" @click="course_id_id=items.id">{{$t('course_index.mail_record')}}</el-button>
										</div>
										<div>
											<el-button size="mini" type="primary" @click="remarks_ff(items)">{{$t('feedback_index.remarks')}}</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="center_id" align="center" :label="$t('course_index.center')" data-name="学习中心">
					<template slot-scope="scope">{{scope.row.center_id | center_f(this_)}}</template>
				</el-table-column>
				<el-table-column prop="half_price" align="center" :label="$t('course_index.half_price')" data-name="半天金额"></el-table-column>
				<el-table-column prop="price" align="center" :label="$t('course_index.full_price')" data-name="全天金额"></el-table-column>
				<el-table-column prop="lunch_price" align="center" :label="$t('course_index.lunch_price')" data-name="午饭金额"></el-table-column>
				<el-table-column prop="look_price" align="center" :label="$t('course_index.look_price')" data-name="课后看护费用"></el-table-column>
				<el-table-column :label="$t('index.operation')" align="center" fixed="right" width="200" data-name="操作">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" v-if="hasBtn('edit')" @click="add(scope.row)" data-name="编辑">{{$t('index.edit')}}</el-button>
						<el-button size="mini" type="primary" v-if="hasBtn('copy')" @click.native="add(scope.row,true)" data-name="复制">{{$t('index.copy')}}</el-button>
						<p class="matop">
							<el-button size="mini" type="danger" v-if="hasBtn('status')&&scope.row.is_up==1" @click="up(scope.row,0)">{{$t('course_index.up_0')}}</el-button>
							<el-button size="mini" type="success" v-if="hasBtn('status')&&scope.row.is_up==0" @click="up(scope.row,1)">{{$t('course_index.up_1')}}</el-button>
							<el-button size="mini" type="info" v-if="hasBtn('del')" @click="del(scope.row)" data-name="删除">{{$t('index.del')}}</el-button>
						</p>
					</template>
				</el-table-column>
			</el-table>
		</el-checkbox-group>
		<pagination :total="pages.count" :page.sync="pages.page" :limit.sync="pages.perpage" @pagination="init" />
		<!-- <div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
		</div> -->
		<el-dialog :title="$t('index.dialog_title')" v-if="editFormVisible" :close-on-click-modal="false" :visible.sync="editFormVisible" width="1200px">
			<div class="dialog-header">
				<el-button size="mini" type="primary" @click.native="add_yizhou">{{$t('course_index.plus')}}</el-button>
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
			<el-form label-width="80px" ref="editForm" :rules="editFormRules" size="mini" label-position="top" :model="editForm">
				<el-row class="tree-content" :gutter="20">
					<!-- <el-col :span="4" v-if="is_co==1">
						<el-form-item :label="$t('course_index.country')" prop="country" data-name="课程所属">
							<el-select v-model="editForm.country" class="w100" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" v-if="item.code!='co'" :value="item.code" :key="index" v-for="(item,index) in DATA_RIGHTS"></el-option>
							</el-select>
						</el-form-item>
					</el-col> -->
					<el-col :span="4">
						<el-form-item :label="$t('course_index.power_type')" prop="power_type" data-name="状态">
							<el-select v-model="editForm.power_type" class="w100" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.code" :key="index" v-for="(item,index) in STATUS"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4" v-if="editForm.power_type=='protected'">
						<el-form-item :label="$t('course_index.password')" prop="password" data-name="密码">
							<el-input v-model="editForm.password " :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.center')" prop="center_id" data-name="学习中心">
							<el-select v-model="editForm.center_id" class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in learnCenter" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.id" v-if="item.course_type==0||item.course_type==2"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.half_price')" prop="half_price" data-name="半天金额">
							<el-input v-model="editForm.half_price" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.full_price')" prop="price" data-name="全天金额">
							<el-input v-model="editForm.price" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.session')" prop="term" data-name="学期">
							<el-select v-model="editForm.term" class="w100" :placeholder="$t('index.pleaseInput')">
								<el-option v-for="(item,index) in SESSION_ARR" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.lunch_price')" prop="lunch_price" data-name="午饭金额">
							<el-input v-model="editForm.lunch_price" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('index.cn')+$t('course_index.title')" prop="title_cn" data-name="名称">
							<el-input v-model="editForm.title_cn" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('index.en')+$t('course_index.title')" prop="title" data-name="名称">
							<el-input v-model="editForm.title" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.look_price1')" prop="look_price" data-name="上午课后看护费用">
							<el-input v-model="editForm.look_price" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.look_price2')" prop="look_price2" data-name="下午课后看护费用">
							<el-input v-model="editForm.look_price2" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('parent_index.seller')" prop="course_seller_id" data-name="销售">
							<el-select v-model="editForm.course_seller_id" class="w100" :placeholder="$t('index.pleaseInput')">
								<el-option v-for="(item,index) in courseSellerList" :key="index" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.is_show_front')" prop="is_show_front" data-name="是否显示再首页">
							<el-switch v-model="editForm.is_show_front" active-color="#ff4949" :active-value="0" :inactive-value="1" inactive-color="#13ce66" :active-text="$t('course_index.hide')" :inactive-text="$t('course_index.show')"></el-switch>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('course_index.zoom')" prop="zoom" data-name="zoom链接">
							<el-input v-model="editForm.zoom" :placeholder="$t('index.pleaseInput')" type="textarea" :autosize="{ minRows: 4, maxRows: 4}"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('course_index.thumb')" prop="thumb" data-name="图片">
							<upload :value="editForm.thumb" name="company" @callback="function(res, file){imageSuccess(res, file,'thumb')}"></upload>
						</el-form-item>
					</el-col>
				</el-row>
				<el-card class="box-card" v-for="(item,index) in editForm.week_data" :key="index">
					<el-row class="tree-content" :gutter="20">
						<el-col :span="4">
							<el-form-item :label="$t('course_index.sort')" prop="sort" data-name="排序">
								<el-input-number v-model="item.sort" :min="1"></el-input-number>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item :label="$t('course_index.date')" :prop="'week_data.'+index+'.date_time'" data-name="日期" :rules="editFormRules.date_time">
								<el-date-picker v-model="item.date_time" class="w100" value-format="timestamp" type="daterange" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.startdate')" :end-placeholder="$t('course_index.enddate')"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item :label="$t('course_index.no_course_dates')" prop="no_course_dates" data-name="不上课日期">
								<el-date-picker type="dates" class="w100" v-model="item.no_course_date" value-format="timestamp" :placeholder="$t('index.select')"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="5">
							<i class="fint el-icon-circle-plus" title="Add a half day camp" @click="add_bantian(index)"></i>
							<i class="fint el-icon-remove" @click="del_yizhou(index)"></i>
							<el-button size="mini" type="primary" class="fint_button" @click.native="add_fizhi(item)">{{$t('course_index.copy')}}</el-button>
						</el-col>
					</el-row>
					<el-card class="box-card" v-for="(items,indexs) in item.camp_theme_data" :key="indexs">
						<el-row class="tree-content" :gutter="20">
							<el-col :span="6">
								<el-form-item :label="$t('index.cn')+$t('course_index.theme')" data-name="中文主题">
									<el-input v-model="items.theme_cn" :placeholder="$t('index.pleaseInput')"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item :label="$t('index.en')+$t('course_index.theme')" prop="theme" data-name="英文主题">
									<el-input v-model="items.theme" :placeholder="$t('index.pleaseInput')"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item :label="$t('course_index.cate')" :prop="'week_data.'+index+'.camp_theme_data.'+indexs+'.cate'" data-name="分类" :rules="editFormRules.cate">
									<el-cascader v-model="items.cate" class="w100" :props="props" :options="camp_list"></el-cascader>
								</el-form-item>
							</el-col>
							<el-col :span="4">
								<el-form-item :label="$t('course_index.teacher')" prop="teacher_id" data-name="老师">
									<el-select v-model="items.teacher_id" class="w100" :placeholder="$t('index.select')">
										<el-option v-for="(item,index) in teacher" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="String(item.teacher_id)"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="1">
								<i class="fint el-icon-remove" @click="del_bantian(index,indexs)"></i>
							</el-col>
							<el-col :span="4">
								<el-form-item :label="$t('course_index.administrators')" prop="seller_id" data-name="管理员">
									<el-select v-model="items.seller_id" multiple class="w100" :placeholder="$t('index.select')">
										<el-option v-for="(item,index) in sellerList" :key="index" :label="item.name" :value="String(item.id)"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="4">
								<el-form-item :label="$t('course_index.is_show_contact')" prop="is_show_contact" data-name="是否显示老师交流">
									<el-switch v-model="items.is_show_contact" active-color="#ff4949" :active-value="0" :inactive-value="1" inactive-color="#13ce66" :active-text="$t('course_index.hide')" :inactive-text="$t('course_index.show')"></el-switch>
								</el-form-item>
							</el-col>
							<el-col :span="4">
								<el-form-item :label="$t('course_index.is_show_evaluation')" prop="is_show_evaluation" data-name="是否显示评估表">
									<el-switch v-model="items.is_show_evaluation" active-color="#ff4949" :active-value="0" :inactive-value="1" inactive-color="#13ce66" :active-text="$t('course_index.hide')" :inactive-text="$t('course_index.show')"></el-switch>
								</el-form-item>
							</el-col>
							<el-col :span="3">
								<el-form-item :label="$t('course_index.max_people')" prop="num" data-name="班级规模">
									<el-input v-model="items.num" :placeholder="$t('index.pleaseInput')"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item :label="$t('course_index.time')" prop="time" data-name="时间" :rules="editFormRules.time">
									<el-time-picker v-model="items.time" format="HH:mm" class="w100" value-format="timestamp" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.starttime')" :end-placeholder="$t('course_index.endtime')" is-range></el-time-picker>
								</el-form-item>
							</el-col>
							<el-col :span="4">
								<el-form-item :label="$t('course_index.age')" prop="min_age" data-name="年龄">
									<el-row class="tree-content" :gutter="0">
										<el-col :span="11">
											<el-input v-model="items.min_age" :placeholder="$t('index.pleaseInput')"></el-input>
										</el-col>
										<el-col class="line" :span="2">-</el-col>
										<el-col :span="11">
											<el-input v-model="items.max_age" :placeholder="$t('index.pleaseInput')"></el-input>
										</el-col>
									</el-row>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- 自定义字段 -->
						<el-row :gutter="10">
							<el-button size="mini" type="primary" class="fint_ma_top" @click.native="field_add(index,indexs)">{{$t('course_index.add_field')}}</el-button>
							<el-col :span="24">
								<el-row :gutter="10" v-for="(itemss,indexss) in items.course_field" :key="indexss">
									<el-col :span="6">
										<el-form-item :label="$t('course_index.field')" :prop="'week_data.'+index+'.camp_theme_data.'+indexs+'.course_field.'+indexss+'.code'" :rules="editFormRules.code" data-name="字段">
											<el-input v-model="itemss.code" :placeholder="$t('index.pleaseInput')"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="6">
										<el-form-item :label="$t('index.cn')+$t('course_index.field_name')" :prop="'week_data.'+index+'.camp_theme_data.'+indexs+'.course_field.'+indexss+'.name_cn'" :rules="editFormRules.name_cn" data-name="字段名">
											<el-input v-model="itemss.name_cn" :placeholder="$t('index.pleaseInput')"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="6">
										<el-form-item :label="$t('index.en')+$t('course_index.field_name')" :prop="'week_data.'+index+'.camp_theme_data.'+indexs+'.course_field.'+indexss+'.name'" :rules="editFormRules.name" data-name="字段名">
											<el-input v-model="itemss.name" :placeholder="$t('index.pleaseInput')"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="4">
										<el-form-item :label="$t('course_index.is_must')" data-name="是否必填">
											<el-checkbox v-model="itemss.is_must" :true-label="1" :false-label="0">{{$t('course_index.required')}}</el-checkbox>
										</el-form-item>
									</el-col>
									<el-col :span="2">
										<i class="fint el-icon-remove" @click="field_del(index,indexs,indexss)"></i>
									</el-col>
								</el-row>
							</el-col>
						</el-row>
					</el-card>
				</el-card>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('course_index.introduce')" prop="introduce_cn" data-name="说明">
							<el-input v-model="editForm.introduce_cn" :placeholder="$t('index.pleaseInput')" type="textarea" :autosize="{ minRows: 5, maxRows: 5}"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('course_index.introduce')" prop="introduce" data-name="说明">
							<el-input v-model="editForm.introduce" :placeholder="$t('index.pleaseInput')" type="textarea" :autosize="{ minRows: 5, maxRows: 5}"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('course_index.content')" prop="content_cn">
							<editor-bar v-model="editForm.content_cn" :isClear="isClear"></editor-bar>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('course_index.content')" prop="content">
							<editor-bar v-model="editForm.content" :isClear="isClear"></editor-bar>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" type="primary" @click.native="add_yizhou">{{$t('course_index.plus')}}</el-button>
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<teacher_camp_list :isdialog="isdialog" :id="teacher_course_index_id" @guanbitanchu="function(e){isdialog=false}"></teacher_camp_list>
		<!-- 选择邮件模板 -->
		<el-dialog :title="$t('course_index.xuanzyoujian')" :close-on-click-modal="false" :visible.sync="xuanzyoujian_is" width="1200px">
			<el-form label-width="80px" ref="form" size="mini" label-position="top" :rules="editFormRules" :model="form">
				<el-row class="tree-content" :gutter="20">
					<el-col :span="6">
						<el-form-item :label="$t('course_index.if_notice')" prop="if_notice" data-name="是否发送开课通知">
							<el-switch v-model="form.is_notice" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
						</el-form-item>
					</el-col>
					<span v-if="form.is_notice">
						<el-col :span="6">
							<el-form-item :label="$t('course_index.youjian_title')" prop="title" data-name="邮件标题">
								<el-input v-model="form.title" :placeholder="$t('index.pleaseInput')"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item :label="$t('course_index.xuanzyoujian')" prop="tmp_id" data-name="邮件">
								<el-select v-model="form.tmp_id" @change="tmp_id_f" class="w100" :placeholder="$t('index.select')">
									<el-option :label="item.title" :value="item.id" :key="index" v-for="(item,index) in tmplist"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item :label="$t('course_index.mail_type')" prop="mail_type" data-name="发送类型">
								<el-select v-model="form.mail_type" class="w100" :placeholder="$t('index.select')">
									<el-option :label="lang=='cn'?item.cn:item.en" :value="item.id" :key="index" v-for="(item,index) in mail_type_list"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="24" v-if="form.mail_type==2">
							<el-form-item :label="$t('course_index.student_list')" prop="title" data-name="学生列表">
								<el-checkbox-group v-model="form.child_ids">
									<el-checkbox :label="item.child_id" v-for="(item,index) in student_list" :key="index">
										<el-badge :is-dot="!item.have_open_mail">{{item.name}}</el-badge>
									</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</el-col>
					</span>
				</el-row>
				<el-row class="tree-content" :gutter="20" v-if="form.is_notice&&form.content">
					<el-col :span="24">
						<el-form-item :label="$t('course_index.xuanzyoujian')" prop="content" data-name="邮件">
							<editor-bar v-model="form.content" :isClear="isClear"></editor-bar>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="xuanzyoujian_is = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="xuanzyoujian_f('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<!-- 绑定管理员 -->
		<el-dialog :title="$t('course_index.administrators')" :close-on-click-modal="false" :visible.sync="seller_id_is" width="500px">
			<el-form label-width="80px" ref="form" size="mini" label-position="top" :rules="editFormRules" :model="form">
				<el-row class="tree-content" :gutter="20">
					<el-col :span="24">
						<el-form-item :label="$t('course_index.administrators')" prop="seller_id" data-name="管理员">
							<el-select v-model="form.seller_id" multiple class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in sellerList" :key="index" :label="item.name" :value="String(item.id)"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="seller_id_is = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="seller_id_f('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<mail_record_list :course_type="course_type" :course_id="course_id_id" @guanbi="course_id_id=0"></mail_record_list>
		<!-- 备注 -->
		<el-dialog :title="$t('feedback_index.remarks')" width="800px" :close-on-click-modal="false" :visible="editFormVisible_1" @close="editFormVisible_1 = false">
			<el-form :model="editForm_1" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm_1">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item :label="$t('feedback_index.remarks')" prop="remarks">
							<el-input v-model="editForm_1.remarks" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible_1 = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit1('editForm_1')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	// import EditorBar from '../../components/wangEnduit.vue'
import teacher_camp_list from '@/components/teacher_camp_list.vue'
import mail_record_list from '@/components/mail_record_list.vue'
export default {
	computed: {
		props() {
			return {
				value: 'id',
				label: this.lang == 'cn' ? 'name_cn' : 'name',
			}
		},
		props_() {
			return {
				checkStrictly: true,
				value: 'id',
				label: this.lang == 'cn' ? 'name_cn' : 'name',
			}
		},
		editFormRules() {
			return{
				title_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('course_index.title'),
					trigger: 'blur'
				}],
				title: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('course_index.title'),
					trigger: 'blur'
				}],
				center_id: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.center'),
					trigger: 'change'
				}],
				half_price: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.half_price'),
					trigger: 'blur'
				}],
				term: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.session'),
					trigger: 'blur'
				}],
				lunch_price: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.lunch_price'),
					trigger: 'blur'
				}],
				look_price: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.look_price'),
					trigger: 'blur'
				}],
				look_price2: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.look_price2'),
					trigger: 'blur'
				}],
				date_time: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.date'),
					trigger: 'blur'
				}],
				tmp_id: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.xuanzyoujian'),
					trigger: 'change'
				}],
				cate: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.cate'),
					trigger: 'change'
				}],
				name: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('course_index.field_name'),
					trigger: 'blur'
				}],
				name_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('course_index.field_name'),
					trigger: 'blur'
				}],
				code: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.field'),
					trigger: 'blur'
				},{
					pattern: /^[a-zA-Z_][a-zA-Z0-9_]+$/,
					message: this.$t('course_index.code'),
					trigger: ['blur', 'change']
				}],
			}
		},
	},
	components: {
		// EditorBar,
		teacher_camp_list,
		mail_record_list
	},
	data() {
		return {
			isClear: false,
			// is_co: sessionStorage.getItem('is_co'),
			// filterForm: {},
			list: [],
			pages: {
				cate:[],
				week_time:'',
				age:'',
				session:'',
				center_id:'',
				teacher_id:'',
				keyword:'',
				id:'',
				week_start_time:'',
				week_end_time:'',
				page: 1,
				count: 0,
				perpage: 10,
			},
			this_:this,
			editForm: {},

			API_URL:process.env.API_URL,
			// image_up: process.env.API_UP,
			API_UP:process.env.API_UP,
			TokenId:sessionStorage.getItem('TokenId'),

			image:'',
			editFormVisible: false,
			// WEEK_ARR: [],
			// TYPE: [],
			SESSION_ARR: [],
			// DATA_RIGHTS: [],
			STATUS: [],
			COURSEAGE_ARR: [],
			learnCenter:[],
			camp_list:[],
			teacher:[],
			sellerList:[],
			courseSellerList:[],
			teacher_course_index_id:0,
			isdialog:false,
			xuanzyoujian_is:false,
			course_id:'',
			form:{
				is_notice:true,
				title:'',
				content:'',
				tmp_id:'',
				mail_type:1,
				seller_id:[],
				child_ids:[],
			},
			tmplist:[],
			seller_id_is:false,
			course_id_array:[],


			student_list:[], //学生列表
			mail_type_list:[
				{
					id:1,
					cn:'全部发送',
					en:'Send all',
				},
				{
					id:2,
					cn:'部分发送',
					en:'Send Partial',
				}
			],
			course_type:'camp',
			course_id_id:0,
			editForm_1:{
				id:'',
				remarks:'',
			},
			editFormVisible_1:false,
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.init();
		// this.default_time();
	},
	// 事件
	methods: {
		config() {
			var this_ = this;
			this.$post('getDictionaryValue', {code:'SESSION_ARR,STATUS,COURSEAGE_ARR'}).then((res) => {
				this.SESSION_ARR = res.SESSION_ARR;
				this.STATUS = res.STATUS;
				this.COURSEAGE_ARR = res.COURSEAGE_ARR;
			})
			this.$post('courseScreen', {}).then((res) => {
				this.learnCenter = res.learnCenter; //学习中心
				this.teacher = res.teacher; //老师
				this.sellerList = res.sellerList; //管理员
				this.courseSellerList = res.courseSellerList; //销售
			})
			this.$post('emailTmpList', {type:'class_starts'}).then((res) => {
				this.tmplist=res;
			})
			this.$post('cateOption', {type:'2',}).then((res) => {
				this.camp_list = this.xunhaun(res.show);
			})
		},
		// 初始化
		init: function () {
			var this_ = this;
			var url = "campIndex"
			var datas = {
				...this.pages,
				num: this.pages.perpage,
			}
			if (this.pages.week_time) {
				var ii=24*60*60;
				var week_time = this.pages.week_time.split('-');
				var date_new=Math.round(new Date(week_time[0],week_time[1]-1,week_time[2],0,0,0).getTime()/1000);
				datas['week_start_time']=date_new-ii;
				datas['week_end_time']=date_new+(ii*6)-1;
				datas['week_time']=date_new+ii;
			}
			if (this.pages.cate&&this.pages.cate.length>0) {
				datas['cate_id']=this.pages.cate[0]||'';
				datas['cate_node_id']=this.pages.cate[1]||'';
				datas['cate_three_id']=this.pages.cate[2]||'';
				delete datas.cate
			}
			this.$post('campIndex', datas).then((res) => {
				this.list = res.list;
				this.pages.count = res.sum;
			})
		},
		// 搜索
		search() {
			this.pages.page = 1;
			this.init();
		},
		// 重置
		reset() {
			this.pages = this.$options.data().pages;
			this.init();
		},
		// 新建或编辑
		add(data,copy) {
			var this_ = this;
			if (data) {
				this.$post('campInfo', {id:data.id}).then((res) => {
					var editForm = res;
					var week_data=res.week_data;
					week_data.forEach(function(e,i) {
						var date_time = [];
						date_time[0]=e.start_date_time?e.start_date_time*1000:'';
						date_time[1]=e.end_date_time?e.end_date_time*1000:'';
						e['date_time']=date_time;
						var no_course_date=[];
						if (e.no_course_date) {
							no_course_date=e.no_course_date.split(',');
							no_course_date.forEach(function(n,j) {
								no_course_date[j]=n*1000;
							});
						}
						e['no_course_date']=no_course_date;
						e.camp_theme_data.forEach(function(n,j) {
							var cate=[];
							if(n.cate_id){
								cate[0]=n.cate_id;
								if(n.cate_node_id){
									cate[1]=n.cate_node_id;
									if(n.cate_three_id){
										cate[2]=n.cate_three_id;
									}
								}
							}
							n['cate']=cate;
							var time=[];
							time[0]=n.start_time?n.start_time*1000:this_.default_time();
							time[1]=n.end_time?n.end_time*1000:this_.default_time();
							n['time']=time;
							var seller_id=[];
							if (n.seller_id) {
								seller_id=n.seller_id.split(',');
							}
							n['seller_id']=seller_id;
						});
					});
					if (copy) {
						editForm['title'] = res.title+'-copy';
						editForm['is_up'] = 0;
						editForm['title_cn'] = res.title_cn+'-复制';
						editForm['id'] = '';
						week_data.forEach(function(e,i) {
							e.camp_theme_data.forEach(function(n,j) {
								var course_field=n.course_field;
								for(var i = 0, length1 = course_field.length; i < length1; i++){
									course_field[i]['id']='';
								}
								n['course_field'] = course_field;
							})
						})
					}
					editForm['week_data'] = week_data;
					this.editForm = editForm;
					if (copy) {
						this.tijiao();
					}else{
						if (this.$refs.editForm) {
							this.$refs.editForm.resetFields();
						}
						this.editFormVisible = true;
					}
				})
			} else {
				this.editForm = {
					power_type: 'public',
					password: '',
					title_cn:'',
					title:'',
					center_id: '',
					half_price: '',
					price: '',
					term: '',
					lunch_price: '',
					look_price: '',
					look_price2: '',
					thumb: '',
					week_data: [],
					content_cn: '',
					content: '',
					introduce_cn: '',
					introduce: '',
					course_seller_id: '',
					is_show_front:0,
					zoom: '',
				}
				if (this.$refs.editForm) {
					this.$refs.editForm.resetFields();
				}
				this.editFormVisible = true;
			}
		},
		// 加一周
		add_yizhou(){
			var sort=this.editForm.week_data.length+1;
			var obj={
				sort:sort,
				date_time:[],
				start_date_time:'',
				end_date_time:'',
				is_show_contact:0,
				is_show_evaluation:0,
				no_course_date:[],
				camp_theme_data: [],
			}
			this.editForm.week_data.push(obj);
		},
		// 加半天
		add_bantian(index){
			var obj={
				theme: '',
				theme_cn: '',
				teacher_id: '',
				start_time: '',
				end_time: '',
				time: [this.default_time(),this.default_time()],
				min_age: '',
				max_age: '',
				cate_id:'',
				cate_node_id:'',
				cate_three_id:'',
				num:'',
				seller_id:[],
				course_field:[],
			}
			this.editForm.week_data[index].camp_theme_data.push(obj);
		},
		// 复制一周
		add_fizhi(data){
			var this_ = this;
			var sort=this.editForm.week_data.length+1;
			var obj=JSON.parse(JSON.stringify(data));
			delete obj.id;
			obj.sort=sort;
			this_.editForm.week_data.push(obj);
			this_.$message.success(this_.$t('course_index.copy_success'));
		},
		//删一周
		del_yizhou(index){
			this.removeByIndex(this.editForm.week_data,index);
		},
		// 删半天
		del_bantian(index,indexs){
			this.removeByIndex(this.editForm.week_data[index].camp_theme_data,indexs);
		},
		// 弹出选择管理员
		seller_id_ff(){
			var this_ = this;
			if (this_.course_id_array.length==0) {
				this_.$message.success(this_.$t('index.please_check'));
			}else{
				this_.seller_id_is=true;
			}
		},
		// 批量绑定管理员
		seller_id_f(){
			var this_ = this;
			this_.$refs.form.validate((valid) => {
				if (valid) {
					var url = "addClassDirectorApi"
					var datas = {
						course_id: this_.course_id_array.join(','),
						seller_id: this_.form.seller_id.join(','),
						course_type:'camp',
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.modify_success'));
						this_.seller_id_is = false;
						this_.init();
					})
				}
			})
		},
		// 保存
		editSubmit() {
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.tijiao();
				}
			})
		},
		// 开始到结束的天数
		getday(unixDb,unixDe){
			var this_ = this;
			var dateArr = new Array();
			for (var k = unixDb; k <= unixDe;) {
				dateArr.push(k);
				var dateTime=new Date(k);
				dateTime.setDate(dateTime.getDate()+1);
				dateTime=new Date(dateTime).getTime();
				k = dateTime;
			}
			return dateArr;
		},
		// 计算天数
		have_date_time(start_date,end_date,start_time,no_course_date){
			var this_ = this;
			var class_num_array=this.getday(start_date*1000,end_date*1000);
			class_num_array.forEach(function(e,i) {
				var zhi=Math.round(e/1000);
				if (no_course_date.indexOf(zhi)!=-1) {
					this_.removeByIndex(class_num_array,i)
				}
			});
			return class_num_array.length>0?class_num_array.join(','):'';
		},
		tijiao(){
			var this_ = this;
			var url = "campAdd";
			var list=JSON.parse(JSON.stringify(this_.editForm.week_data));
			list.forEach(function(e,i) {
				if (e.date_time.length>0&&e.camp_theme_data.length>0&&e.camp_theme_data[0].time.length>0) {
					// 日期
					e['start_date_time']=this_.shijian(e.date_time[0],e.camp_theme_data[0].time[0]);
					e['end_date_time']=this_.shijian(e.date_time[1],e.camp_theme_data[e.camp_theme_data.length-1].time[1]);
					// 不上课日期
					var no_course_date=e.no_course_date||[];
					no_course_date.forEach(function(n,j) {
						no_course_date[j]=this_.shijian(n,e.camp_theme_data[0].time[0]);
					});
					e['no_course_date']=no_course_date.join(',');
					// 时间
					e.camp_theme_data.forEach(function(n,j) {
						if (n.time.length>0) {
							n['start_time']=this_.shijian(e.date_time[0],n.time[0]);
							n['end_time']=this_.shijian(e.date_time[0],n.time[1]);
						}
						if (n.cate&&n.cate.length>0) {
							n['cate_id']=n.cate[0]||'';
							n['cate_node_id']=n.cate[1]||'';
							n['cate_three_id']=n.cate[2]||'';
						}
						if (n.seller_id&&n.seller_id.length>0) {
							n['seller_id']=n.seller_id.join(',');
						}
						// 上课时间
						n['have_date_time']=this_.have_date_time(e['start_date_time'],e['end_date_time'],n['start_time'],e['no_course_date']);	
						// console.log(n['have_date_time'])

						n['course_field']=JSON.stringify(n.course_field);
					});
				}
			});
			var week_data=JSON.stringify(list);
			var datas = {
				country:'us',
				power_type: this_.editForm.power_type,
				password: this_.editForm.password,
				title_cn: this_.editForm.title_cn,
				title: this_.editForm.title,
				center_id: this_.editForm.center_id,
				half_price: this_.editForm.half_price,
				price: this_.editForm.price,
				term: this_.editForm.term,
				lunch_price: this_.editForm.lunch_price,
				look_price: this_.editForm.look_price,
				look_price2: this_.editForm.look_price2,
				content_cn: this_.editForm.content_cn,
				content: this_.editForm.content,
				introduce_cn: this_.editForm.introduce_cn,
				introduce: this_.editForm.introduce,
				zoom: this_.editForm.zoom,
				is_show_front: this_.editForm.is_show_front,
				course_seller_id: this_.editForm.course_seller_id,
				week_data:week_data,
			}
			if (this_.image) {
				datas['thumb']=this_.image;
			}
			var tishi = this_.$t('index.add_success');
			if (this_.editForm.id) {
				datas['camp_id'] = this_.editForm.id;
				tishi = this_.$t('index.modify_success');
				url = "campEdit";
			}
			this_.$post(url, datas).then((res) => {
				this_.$message.success(tishi);
				this_.editFormVisible = false;
				this_.image='';
				this_.init();
			});
		},
		// 设置开始结束时间
		shijian(start_date,start_time,quj){
			var y=this.getti(start_date,'y');
			var m=this.getti(start_date,'m');
			var d=this.getti(start_date,'d');
			var h=this.getti(start_time,'h');
			var i=this.getti(start_time,'i');
			var s=this.getti(start_time,'s');
			let datetime = Math.round(new Date(y,m,d,h,i,s).getTime()/1000);
			return datetime
		},
		getti(data,ss){
			let datetime = new Date(data);
			// console.log(datetime)
			let year = datetime.getFullYear();
			let month = datetime.getMonth();
			let date = datetime.getDate();
			let hour = datetime.getHours();
			let minute = datetime.getMinutes();
			let second = datetime.getSeconds();
			if (ss=='y') {
				return year
			}else if(ss=='m'){
				return month
			}else if(ss=='d'){
				return date
			}else if(ss=='h'){
				return hour
			}else if(ss=='i'){
				return minute
			}else if(ss=='s'){
				return second
			}
		},
		del(data) {
			var this_ = this;
			var url = "campDelete";
			var datas = {
				camp_id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		up(data,value){
			var this_ = this;
			var url = "changeField";
			var datas = {
				pk_id: data.id,
				table:'camp',
				field:'is_up',
				value:value,
			};
			this_.$post(url, datas).then((res) => {
				this_.$message.success(this_.$t('index.delete_success'));
				this_.init();
			})
		},
		exportCamp(data){
			var course_id=data.id;
			var TokenId = sessionStorage.getItem('TokenId');
			var lang  = localStorage.getItem('lang')!='cn'?'us':'cn';
			var url =  process.env.API_ROOT+'exportCamp?TokenId='+TokenId+'&language='+lang+'&camp_week_id='+course_id;
			window.open(url);
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		imageSuccess(res, file, name) {
			if (res.status == 200) {
				this.editForm[name] = res.data.showname;
				this.image = res.data.savename;
				this.$refs.editForm.clearValidate(name);
			} else {
				this.$message.success(res.message);
			}
		},
		cate_id_f(id){
			var camp_list=this.camp_list;
			var fanhuizhi='';
			camp_list.forEach(function(e,i) {
				if (e.id==id) {
					fanhuizhi=e.parent_id;
				}
			});
			return fanhuizhi
		},
		default_time(){
			var y=this.getTime('','y')+' 00:00:00';
			var time_=new Date(y).getTime();
			return time_;
		},
		// 开课
		kaike(data){
			var this_ = this;
			this_.$confirm(this_.$t('index.confirm_kaiying'), this_.$t('index.tips')).then(() => {
				// 获取学生列表
				var url = "courseClasses"
				var datas = {
					course_id: data.id,
					type:'camp',
				}
				this_.$post(url, datas).then((res) => {
					this_.editForm=JSON.parse(JSON.stringify(data));
					this_.course_id=data.id;
					this_.xuanzyoujian_is=true;
					this_.form = this_.$options.data().form;
					this_.student_list=res.student;
				})
			})
		},
		tmp_id_f(){
			var this_ = this;
			var tmplist=this_.tmplist;
			var tmp_id=this_.form.tmp_id;
			tmplist.forEach(function(e,i) {
				if (e.id==tmp_id) {
					this_.form.content=e.content;
				}
			});
		},
		xuanzyoujian_f(){
			var this_ = this;
			this_.$refs.form.validate((valid) => {
				if (valid) {
					var url = "openCourse"
					var datas = {
						course_id: this_.course_id,
						type:'camp',
					}
					this_.$post(url, datas).then((res) => {
						if (this_.form.is_notice) {
							this_.youjian();
						}else{
							this_.$message.success(this_.$t('index.operation_success'));
							this_.xuanzyoujian_is=false;
							this_.init();
						}
					})
				}
			})
		},
		// 发送邮件
		youjian(){
			var this_ = this;
			var url="openCourseSendEmail";
			var datas={
				course_id:this_.course_id,
				course_type:'camp',
				title:this_.form.title,
				content:this_.form.content,
				child_ids:'',
			}
			if (this_.form.mail_type==2) {
				datas.child_ids=this_.form.child_ids.join(',');
			}
			this_.$post(url, datas).then((res) => {
				this_.$message.success(this_.$t('index.operation_success'));
				this_.xuanzyoujian_is=false;
				this_.init();
			})
		},
		before_upload(){
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},
		imageSuccess_f(res){
			if (res.status == 200) {
				this.$message.success(res.message);
				this.reset();
			} else {
				this.$message.error(res.status);
			}
			if (this.loading) {
				this.loading.close();
			}
		},



		// date_picker_change(date){
		// 	console.log(date)
		// 	if (date) {
		// 		var ii=24*60*60;
		// 		var yy=parseInt(date.split('-')[0]);
		// 		var mm=parseInt(date.split('-')[1]);
		// 		var dd=parseInt(date.split('-')[2]);
		// 		var date_new=Math.round(new Date(yy,mm-1,dd,0,0,0).getTime()/1000);
		// 		var week_start_time=date_new-ii;
		// 		var week_end_time=date_new+(ii*6)-1;
		// 		this.filterForm['week_start_time']=week_start_time;
		// 		this.filterForm['week_end_time']=week_end_time;
		// 	}else{
		// 		this.filterForm['week_start_time']='';
		// 		this.filterForm['week_end_time']='';
		// 	}
		// },
		remarks_ff(data){
			this.editForm_1.id=data.id;
			this.editForm_1.remarks=data.remarks;
			this.editFormVisible_1=true;
		},
		editSubmit1(editForm){
			var this_ = this;
			this_.$refs[editForm].validate((valid) => {
				if (valid) {
					var datas = {
						table: 'camp_theme',
						field: 'remarks',
						value: this_.editForm_1.remarks,
						pk_id: this_.editForm_1.id,
					}
					var url = "changeField";
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.add_success'));
						this_.editFormVisible_1 = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		field_add(index,indexs){
			var obj={
				code:'',
				name:'',
				name_cn:'',
				is_must:0,
			}
			this.editForm.week_data[index].camp_theme_data[indexs].course_field.push(obj);
		},
		field_del(index,indexs,indexss){
			this.removeByIndex(this.editForm.week_data[index].camp_theme_data[indexs].course_field,indexss);
		},
		importtemplate(){
			var url =  process.env.API_ROOT+'../upload/download/tmp_camp.xls';
			console.log(url)
			window.open(url);
		},
	},
	// 过滤器
	filters: {
		index_f(v,this_){
			var cn_array=['第一周','第二周','第三周','第四周','第五周','第六周','第七周','第八周','第九周','第十周'];
			var en_array=['First week','The second week','The third week','Fourth week','Week five','Week six','Week Seven','Week Eight','Week Nine','Week Ten'];
			var fanhuizhi=en_array[v];
			if (this_.lang=='cn') {
				fanhuizhi=cn_array[v];
			}
			return fanhuizhi;
		},
		term_f(v,this_){
			var list = this_.SESSION_ARR;
			var fanhuizhi = "";
			list.forEach(function (e, i) {
				if (e.code == v) {
					fanhuizhi = this_.lang == "cn" ? e.name_cn : e.name;
				}
			});
			return fanhuizhi
		},
		center_f(v,this_){
			var list = this_.learnCenter;
			var fanhuizhi = "";
			list.forEach(function (e, i) {
				if (e.id == v) {
					fanhuizhi = this_.lang == "cn" ? e.name_cn : e.name;
				}
			});
			return fanhuizhi
		}
	}
}
</script>
<style>
.el-date-editor .el-range-separator {
	width: 30px;
}

.editor .text {
	min-height: 200px;
}

.el-checkbox {
	white-space: inherit;
}

</style>
<style scoped>
.upload_ {
	display: inline-block;
	margin-left: 10px;
}

.fint_button {
	vertical-align: bottom;
}

.filter-inline-panel {
	margin-bottom: 18px;
}

.filter-panel {
	display: inline-block;
	width: calc(100% - 215px);
	vertical-align: top;
}

.matop {
	margin-top: 10px;
}

.box-card {
	margin-bottom: 10px;
}

.fint {
	font-size: 28px;
	margin-top: 30px;
	cursor: pointer;
}

.line {
	text-align: center;
}

.clo3 {
	color: #ff0000;
}

.dialog-header {
	text-align: right;
	padding-bottom: 20px;
}

.kuai {
	display: flex;
	align-items: center;
	padding: 10px 0;
}

.kuai .neir {
	flex: 1;
}

.kuai .anjian {
	display: flex;
	align-items: center;
}

.kuai .anjian .jeishao {
	padding: 0 10px;
}

.kuai .anjian .duqi {
	flex: 1;
}

.kuai .anjian .duqi>div+div {
	margin-top: 10px;
}

.el-date-editor.el-input__inner.w100 {
	width: 100%;
}

.fint {
	font-size: 28px;
	margin-top: 30px;
	cursor: pointer;
}

/*.fint_ma_top{
	margin-top: 30px;
}*/

</style>
<style type="text/css">
textarea {
	font-family: inherit;
}

.kuai+.kuai,
.kuai_kuai+.kuai_kuai {
	border-top: solid 1px #999;
}

.teacher_course_camp.el-table--border td,
.teacher_course_camp.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
	border-bottom-color: #999;
}

</style>



// WEBPACK FOOTER //
// src/views/teacher/course_camp.vue